import { FC } from 'react'

import { routes } from 'utils/routes'
import { Section } from 'components/section'
import { cn } from 'utils'

import { PartnerPortalLayout } from '../partner-portal-layout'
import classes from './auth-partner-portal-layout.module.css'

interface AuthPartnerPortalLayoutProps {
  classNameSection?: string
  classNameDivWrapper?: string
}

export const AuthPartnerPortalLayout: FCRC<AuthPartnerPortalLayoutProps> = ({
  children,
  classNameSection,
  classNameDivWrapper,
}) => {
  return (
    <PartnerPortalLayout backLink={routes.homePage} backLinkText="Back to rezitrade.com">
      <Section className={cn(classes.section, classNameSection)}>
        <div className={classNameDivWrapper}>{children}</div>
      </Section>
      <div className={classes.bg} />
    </PartnerPortalLayout>
  )
}
